function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 1.28C7.87798 1.28 1.28003 7.87795 1.28003 16C1.28003 24.122 7.87798 30.72 16 30.72C24.1221 30.72 30.72 24.122 30.72 16C30.72 7.87795 24.1221 1.28 16 1.28ZM16 2.56C23.4303 2.56 29.44 8.56971 29.44 16C29.44 23.4303 23.4303 29.44 16 29.44C8.56974 29.44 2.56003 23.4303 2.56003 16C2.56003 8.56971 8.56974 2.56 16 2.56ZM16 7.04C15.4908 7.04 15.0025 7.24228 14.6424 7.60235C14.2823 7.96242 14.08 8.45078 14.08 8.96C14.08 9.46921 14.2823 9.95757 14.6424 10.3176C15.0025 10.6777 15.4908 10.88 16 10.88C16.5092 10.88 16.9976 10.6777 17.3577 10.3176C17.7177 9.95757 17.92 9.46921 17.92 8.96C17.92 8.45078 17.7177 7.96242 17.3577 7.60235C16.9976 7.24228 16.5092 7.04 16 7.04ZM13.44 13.44V14.72H14.08H14.72V23.04H14.08H13.44V24.32H14.08H14.72H17.28H17.92H18.56V23.04H17.92H17.28V13.44H16.64H14.08H13.44Z",
  fill: "currentColor"
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.98d89988.svg";
export { ForwardRef as ReactComponent };